// Same approach as filters dropdown in mobile.
import { useEffect, useRef, useState } from "react";
import { useSortBy } from "react-instantsearch";
import SortMobileModal from "./SortMobileModal";
import Portal from "../Portal/Portal";
import { algoliaConfig } from "../../data/config";

export default function Sort() {
    const { 
        initialIndex, 
        currentRefinement,
        options,
        refine,
        canRefine
    } = useSortBy({
        items: [
            { label: 'Relevance', value: algoliaConfig.MATERIAL_INDEX},
            { label: 'Alphabetical', value: `${algoliaConfig.MATERIAL_INDEX}_alphabetical`},
            { label: 'New Release', value: `${algoliaConfig.MATERIAL_INDEX}_new-release`}
        ]
    });
    
    const [selectedSort, setSelectedSort] = useState("Relevance");
    const [isOpen, setIsOpen] = useState(false);
    const [isMbModalOpen, setMbModalOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement | null>(null);

    const handleClickOutside = (event: MouseEvent) => {
        if(dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    }

    const handleDropdownToggle = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        event.preventDefault();
        setIsOpen(!isOpen);
    }

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        }
    }, [])

    const getWindowValue = (label: string) => {
        if(label === "Relevance" && window.steelcase_i18n["steelcase-finish-library"] && window.steelcase_i18n["steelcase-finish-library"].sort.relevance) {
            return window.steelcase_i18n["steelcase-finish-library"].sort.relevance
        }

        if(label === "Alphabetical" && window.steelcase_i18n["steelcase-finish-library"] && window.steelcase_i18n["steelcase-finish-library"].sort.alphabetical) {
            return window.steelcase_i18n["steelcase-finish-library"].sort.alphabetical
        }

        if(label === "New Release" && window.steelcase_i18n["steelcase-finish-library"] && window.steelcase_i18n["steelcase-finish-library"].sort.new_release) {
            return window.steelcase_i18n["steelcase-finish-library"].sort.new_release;
        }

        return label;
    }
    
    return (
        <div className={"finish-sort__container"}>
            <button className={"finish-sort__button hide-mobile"} onClick={handleDropdownToggle}> {window.steelcase_i18n['steelcase-finish-library'].sort.sort_by || "Sort by"} {selectedSort} </button>
            <button className={"finish-filters__button finish-filters__button--full-width show-mobile"} onClick={() => setMbModalOpen(true)}>{window.steelcase_i18n['steelcase-finish-library'].sort.sort_by || "Sort by"}</button>
            <div ref={dropdownRef} className={`finish-sort__popover ${ isOpen ? "" : "finish-sort__popover--hide"}`}>
                {
                    options.map((option, idx) => {
                        return (
                            <div className={"finish-sort__option"} key={idx}>
                                <label className={"finish-sort__label"}>
                                    <input 
                                        key={`${option.label}-desktop`}
                                        className={"finish_sort__control"} 
                                        checked={currentRefinement === option.value} 
                                        type="radio" id={option.label} 
                                        name="sort_by" 
                                        onClick={() => {
                                            refine(option.value)
                                            setSelectedSort(option.label)
                                        }}
                                    />
                                    <span><span className={`${currentRefinement === option.value ? "finish-sort__label-checked" : ""}`}></span>{getWindowValue(option.label)}</span>
                                </label>
                            </div>
                        )
                    })
                }
            </div>
            <Portal wrapperId="sort-wrapper">
                <SortMobileModal isOpen={isMbModalOpen} handleClose={() => setMbModalOpen(false)} sortOptions={options} handleRefinement={(value: string) => refine(value)} />
            </Portal>
        </div>
    )
}
